import { TableCell } from "../../../types/table";

export const itemsListHeadCells: TableCell[] = [
  {
    id: "logo",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "client.name",
  },
  {
    id: "code",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "client.code",
  },
  {
    id: "domain",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "client.domain",
  },
  {
    id: "is_enabled",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "client.enable",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "",
  },
];
